// Set Zoom call in session
export const SET_ZOOM_CALL_IN_SESSION = 'set_zoom_call_in_session'; // THIS user is in the Zoom call
export const SET_ZOOM_CALL_CURRENTLY_ACTIVE = 'set_zoom_call_currently_active'; // Zoom call is active but THIS user is not in it yet

// Zoom Create a meeting
export const MANAGE_ZOOM_MEETING_LINK_REQUEST = 'manage_zoom_meeting_link_request';
export const MANAGE_ZOOM_MEETING_LINK_SUCCESS = 'manage_zoom_meeting_link_success';
export const MANAGE_ZOOM_MEETING_LINK_FAILURE = 'manage_zoom_meeting_link_failure';

// Zoom JWT Token
export const GET_ZOOM_JWT_TOKEN_REQUEST = 'get_zoom_jwt_token_request';
export const GET_ZOOM_JWT_TOKEN_SUCCESS = 'get_zoom_jwt_token_success';
export const GET_ZOOM_JWT_TOKEN_FAILURE = 'get_zoom_jwt_token_failure';
export const GET_ZOOM_JWT_TOKEN_RESET = 'get_zoom_jwt_token_reset';